module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dialogTitle":"Edit range","rangesActionsEditOneSuccess":"%{rangesName} was successfully updated in the database"},"no":{"dialogTitle":"Rediger skyttebane","rangesActionsEditOneSuccess":"%{rangesName} ble redigert i databasen"}}')
  delete Component.options._Ctor
}
